import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, BookOpen, MessageSquare, HelpCircle, Users as UsersIcon, Award, LogOut, FileText, Settings, Home as HomeIcon, Info, Phone, Users2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useAdminAuth } from '../../contexts/AdminAuthContext';

export const AdminLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, adminEmail } = useAdminAuth();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/classes', label: 'Classes', icon: BookOpen },
    { path: '/admin/messages', label: 'Messages', icon: MessageSquare },
    { path: '/admin/faqs', label: 'FAQs', icon: HelpCircle },
    { path: '/admin/policies', label: 'Policies', icon: FileText },
    { path: '/admin/testimonials', label: 'Testimonials', icon: UsersIcon },
    { path: '/admin/partners', label: 'Partners', icon: Award },
    { path: '/admin/content/home', label: 'Edit Home', icon: HomeIcon },
    { path: '/admin/content/about', label: 'Edit About', icon: Info },
    { path: '/admin/content/contact', label: 'Edit Contact Info', icon: Phone },
    { path: '/admin/content/services-group', label: 'Edit Group Training', icon: Users2 },
    { path: '/admin/settings', label: 'Settings', icon: Settings },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <div className="w-64 bg-gray-900 text-white flex flex-col">
        <div className="p-6 border-b border-gray-800">
          <h1 className="text-xl font-bold">PUSH Training - NC</h1>
          <p className="text-sm text-gray-400">Admin Panel</p>
        </div>
        <nav className="flex-1 p-4 overflow-y-auto">
          <Link
            to="/home"
            className="flex items-center gap-3 px-4 py-3 rounded-lg mb-4 text-gray-300 hover:bg-gray-800 border border-gray-700 transition-colors"
          >
            <HomeIcon size={20} />
            <span>View Website</span>
          </Link>
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-colors ${
                  isActive(item.path)
                    ? 'bg-red-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800'
                }`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-gray-800">
          <div className="text-sm text-gray-400 mb-2">{adminEmail}</div>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full border-gray-700 text-gray-300 hover:bg-gray-800"
          >
            <LogOut size={16} className="mr-2" />
            Logout
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <header className="bg-white border-b border-gray-200 px-8 py-4">
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
        </header>
        <main className="flex-1 p-8 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};
